import { Industry } from '@clipr/lib';
import { DropdownItemObject } from '../../components/input/dropdownInput';
import { camelPad } from '../../core/string';

export type JobIndustry = Industry;

 
export const JobIndustry: JobIndustry[] = [
  'AccomodationFoodServices',
  'AdministrationBusinessWasteServices',
  'AgricultureForestryFishingHunting',
  'ArtsEntertainmentRecreation',
  'Construction',
  'EducationalServices',
  'FinanceInsurance',
  'HealthcareSocialAssistance',
  'Information',
  'Manufacturing',
  'Mining',
  'OtherServices',
  'ProfessionalScientificTechnicalServices',
  'PublicSafety',
  'RealEstateRentalLeasing',
  'RetailTrade',
  'TransportationWarehousing',
  'Utilities',
  'WholesaleTrade',
];

export const getJobIndustryLabel = (industry: Industry): string => {
  switch (industry) {
    case 'AccomodationFoodServices':
    case 'AdministrationBusinessWasteServices':
    case 'AgricultureForestryFishingHunting':
    case 'ArtsEntertainmentRecreation':
    case 'Construction':
    case 'EducationalServices':
    case 'FinanceInsurance':
    case 'HealthcareSocialAssistance':
    case 'Information':
    case 'Manufacturing':
    case 'Mining':
    case 'OtherServices':
    case 'ProfessionalScientificTechnicalServices':
    case 'RealEstateRentalLeasing':
    case 'RetailTrade':
    case 'TransportationWarehousing':
    case 'Utilities':
    case 'WholesaleTrade':
    case 'PublicSafety':
    default:
      return camelPad(industry);
  }
}

export const getDefaultJobIndustry = (): Industry => {
  return 'PublicSafety';
}

export const getJobIndustryInputLabel = (): string => {
  return 'Industry';
}

export const SpecialityItems: DropdownItemObject[] = JobIndustry
  .map(item => ({ value: item, label: getJobIndustryLabel(item) }));

export const DefaultJobIndustryItem: DropdownItemObject | null = SpecialityItems.find(({ value }) => value === getDefaultJobIndustry()) || null;